import { render, staticRenderFns } from "./status-form-auth.vue?vue&type=template&id=535b1552&scoped=true&"
import script from "./status-form-auth.vue?vue&type=script&lang=js&"
export * from "./status-form-auth.vue?vue&type=script&lang=js&"
import style0 from "./status-form-auth.vue?vue&type=style&index=0&id=535b1552&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b1552",
  null
  
)

export default component.exports